import script from "./IndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexView.vue?vue&type=script&setup=true&lang=js"

import "../../assets/css/lvr-styles.css?vue&type=style&index=0&rel=stylesheet&lang=css"

const __exports__ = script;

export default __exports__